<template>
  <v-flex xs4 v-if="post.status == 'published'">
    <v-card v-if="post.active" xs4>
      <v-img :src="post.background" height="200px"></v-img>
      <v-card-title primary-title>
        <div class="max-width-100">
          <h3 class="headline mb-1 mt-1">{{ post.title }}</h3>
          <span class="grey--text">{{ post.published.seconds | moment }}</span><br><br>
          <div class="description">{{ post.description }}</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn :to="{ name: 'Post', params: {slug: post.slug} }" v-if="(post.type=='app')" flat color="primary">Try</v-btn>
        <v-btn :to="{ name: 'Post', params: {slug: post.slug} }" v-if="(post.type=='article')" flat color="primary">Read Article</v-btn>
        <v-btn :to="{ name: 'Post', params: {slug: post.slug} }" v-if="(post.type=='audio')" flat color="primary">Listen</v-btn>
        <v-btn :to="{ name: 'Post', params: {slug: post.slug} }" v-if="(post.type=='video')" flat color="primary">Watch</v-btn>
        <v-btn :href="post.content" v-if="(post.type=='resource')" :target="_blank" flat color="primary">Download</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import moment from 'moment'
export default {
  name: 'PostCard',
  props: ['post'],
  methods: {

  },
  data() {
    return {
      published_date: 'nothin'
    }
  },
  filters: {
    moment: function( unix ) {
      return moment.unix(unix).format('MMMM Do, YYYY')
    }
  },
  created() {
    console.log('store', this.$store)
  }
}
</script>

<style>
  .v-card__actions {
    flex-direction: row-reverse;
  }
  .flex {
    max-width: 50%;
  }
  .max-width-100 {
    max-width: 100%;
  }
  .description {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    min-height: 63px;
  }
</style>
